import { ShareActions, ShareImage } from "@/components/share/SharePopup";

export const GlimpseShare = () => (
  <div className="cg-card p-6 sm:p-8" data-testid="glimpse-share">
    <p className="cg-eyebrow mb-2">Optional</p>
    <h2 className="font-serif text-3xl text-[#F3F4F6]">Share Your Authority Glimpse</h2>
    <p className="text-[#B9BDC7] mt-3 leading-relaxed">You've taken the first step towards exploring where your authority lies. Share your experience and invite someone else to discover theirs.</p>
    <ShareImage className="mt-6 max-w-[340px]" />
    <div className="mt-6 max-w-xl mx-auto"><ShareActions source="glimpse" placement="inline" /></div>
    <p className="mt-2 text-xs text-[#6B7280] text-center">Nothing is posted for you. The image contains no personal results.</p>
  </div>
);
